import React, { useContext, useEffect, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  SidebarLayout,
  Section,
  IconLabel
} from "../../../../../components/shared";
import { MainMenu } from "../../../../../components/coordinator/shared";
import { DataConnectionService } from "../../../../../services";
import { coordinator } from "../../../../../graphql/coordinator";
import { MenuContext } from "../../../../../contexts/shared/menu";
import {
  formatMonitoringReportFilters,
  MonitoringServicesList
} from "../../../../../components/admin/experts/services/monitoring";
import {
  useControlledPagination,
  useQueryFilters
} from "../../../../../helpers";
import {
  PaginationContext,
  ServiceDetailModalProvider
} from "../../../../../contexts/shared";
import { FilterControls } from "../../../../../components/admin/experts/services/monitoring/filter-controls";
import { CurrentUserContext } from "../../../../../contexts/shared/current-user";
import { message } from "antd";
import { ProfileVerifierProvider } from "../../../../../contexts/shared/profile-verifier";

export function MonitoringServicesIndex() {
  const [state, setState] = useState({ data: undefined });
  const { currentUser } = useContext(CurrentUserContext);

  const { loading, error, data, refetch, variables } = useQuery(
    coordinator.queries.getMonitoringServicesByCoordinatorId,
    {
      client: DataConnectionService.graphqlApolloClient,
      variables: {
        where: { coordinatorId: currentUser.id },
        first: 12
      },
      fetchPolicy: "network-only"
    }
  );

  useEffect(() => {
    setState({ data });
  }, [data]);

  const { setMenuState } = useContext(MenuContext);

  const { filters, applyFilters } = useQueryFilters({
    refetch,
    defaultFilters: {
      where: {
        coordinatorId: currentUser.id
      },
      first: 12
    }
  });

  const onExport = async ({
    turnExportLoaderOn,
    dismissExportLoader,
    variables
  }) => {
    const where = formatMonitoringReportFilters(filters);

    try {
      turnExportLoaderOn();
      const response = await DataConnectionService.graphqlApolloClient.query({
        query: coordinator.queries
          .getScheduledExpertServicesReportByCoordinatorId,
        fetchPolicy: "network-only",
        variables: {
          where,
          markAsPaid: variables.markAsPaid
        }
      });

      refetch && await refetch();

      window.open(response.data.reportScheduledExpertServices.url, "_blank");
    } catch (e) {
      console.error(e);

      message.error("Ocurrio un error al generar el reporte,\
      inténtalo de nuevo en unos segundos.");
    } finally {
      dismissExportLoader();
    }
  };

  const { currentPage, onPaginationChange } = useControlledPagination({
    initialPageSize: 12
  });

  const onFilterChange = filter => {
    const { skip, pageSize: first } = onPaginationChange(1);

    applyFilters((prevFilters = {}) => ({
      where: {
        ...(prevFilters.where || {}),
        ...filter,
        coordinatorId: currentUser.id
      },
      skip,
      first
    }));
  };

  /* set menu's current state */
  useEffect(() => {
    setMenuState({
      openKeys: ["experts"],
      selectedKeys: ["experts/services/monitoring"]
    });
  }, []);

  if (error) {
    return (
      <IconLabel icon={<ExclamationCircleOutlined />}>
        Ocurrió un error
      </IconLabel>
    );
  }

  const { registerRefetch } = useContext(PaginationContext);

  registerRefetch("monitoring", refetch, variables);

  return (
    <ServiceDetailModalProvider refetch={refetch}>
      <SidebarLayout menu={<MainMenu />}>
        <ProfileVerifierProvider>
          <Section
            style={{ margin: "15px 20px" }}
            extra={
              <FilterControls
                onChange={onFilterChange}
                onClickExport={onExport} />
            }>
            <MonitoringServicesList
              currentPage={currentPage}
              onChangePage={onPaginationChange}
              loading={loading}
              data={state.data}
              refetch={refetch} />
          </Section>
        </ProfileVerifierProvider>
      </SidebarLayout>
    </ServiceDetailModalProvider>
  );
}
